import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCCpyV18sO4QOkv0aJ0tMFIPnjeMRo7JxU",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "projectly-dev.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "projectly-dev",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "projectly-dev.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "318029850180",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:318029850180:web:521dd983710635054e7e11",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-Z5KZZ7LTC0"
};

const app = initializeApp(firebaseConfig);
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage   = getStorage(app);

// Local end-to-end testing against the Firebase Emulator Suite.
// Activated only when REACT_APP_USE_EMULATORS === 'true' (set by the e2e
// scripts). Never runs in production builds, so live data is untouched.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  const host = process.env.REACT_APP_EMULATOR_HOST || 'localhost';
  // eslint-disable-next-line no-console
  console.log(`[firebase] Connecting to emulators on ${host}`);
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(db, host, 8080);
  connectFunctionsEmulator(functions, host, 5001);
  connectStorageEmulator(storage, host, 9199);
}